<template>
  <v-container fluid>
    <material-card
      icon="mdi-format-list-bulleted-square"
      inline
      title="Royalty Setting"
    >
      <!-- <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }"> -->
      <form @submit.prevent="save">
        <v-row>
          <v-col cols="12" md="6" lg="3">
            <v-autocomplete
              label="Select Academic Year*"
              placeholder="--Select--"
              v-model="academicYearID"
              required
              :items="academicYears"
              key="id"
              item-value="id"
              @input="() => getAYStartDate(academicYearID)"
              item-text="academicYear"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-dialog
              ref="dialog1"
              v-model="modal"
              :return-value.sync="fromDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Date"
                  disabled
                  v-model="fromDate"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog1.save(fromDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" lg="3" class="d-flex align-center">
            <v-checkbox v-model="isService" label="isService"></v-checkbox>
          </v-col>
          <v-col cols="12" md="6" lg="3" class="d-flex align-center">
            <v-btn elevation="1" color="primary" type="submit">
              <v-icon left> mdi-content-save </v-icon>
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </form>
      <!-- </v-card-text> -->
      <v-divider class="my-0" />
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
// @ is an alias to /src
// import stores from '@/stores'
import Utils from '@/utils'
import moment from 'moment'
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import _ from 'lodash'

export default {
  name: 'RoyaltySettingAll',
  components: { MaterialCard },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      isLoading: false,
      academicYearID: '',
      academicYears: [],
      modal: false,
      fromDate: null,
      isService: false
    }
  },
  async created () {
    await this.getYear()
  },
  computed: {},
  methods: {
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`
        )
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        const AYStartDate = academicYear.academicYear.split('-')
        this.fromDate = moment(`${AYStartDate[0]}/01/01`, 'YYYY/MM/DD').format(
          'YYYY-MM-DD'
        )
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getAYStartDate: async function (academicYearID) {
      let academicYear = this.academicYears.find((y) => {
        return Number(y.id) === Number(academicYearID)
      })
      const AYStartDate = academicYear.academicYear.split('-')
      this.fromDate = moment(`${AYStartDate[0]}/01/01`, 'YYYY/MM/DD').format(
        'YYYY-MM-DD'
      )
    },
    save: async function () {
      this.hasClicked = true
      this.loader = true
      if (!this.academicYearID) {
        return this.errMsg('Kindly Select Academic Year')
      }
      if (!this.fromDate) {
        return this.errMsg('Kindly Select Date')
      }
      let payload = {
        academicYearID: this.academicYearID,
        startDate: this.fromDate,
        isService: this.isService
      }
      try {
        await http.post(
          `${constants.API_URL}/api/fee-installment/royalty/setting`,
          payload
        )
        this.okMsg('Royalty Settings completed successfully!.')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While updating: ${errorMessage}`)
      }
    },

    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
